/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces the product name ("CorbMax", or the upstream "Chatwoot" still present in
   * locales that were not rebranded; any casing) in text with the installation name
   * from global config
   * @param {string} text - The text to process
   * @returns {string} - Text with the product name replaced by the installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName = globalConfig.value?.installationName;
    if (!installationName) return text;

    return text.replace(/chatwoot|corbmax/gi, installationName);
  };

  return {
    replaceInstallationName,
  };
}
